import { FieldValue } from './field.class'

export class AttachmentValue extends FieldValue<string> {
  public file: File | null
  public originalName: string
  public url: string

  constructor(f?: File, fileName?: string) {
    super()
    this.file = f ?? null
    this.originalName = fileName ?? ''
    this.url = ''
    this.value = fileName ?? undefined
  }

  public mapField(field: AttachmentValue): void {
    this.value = field.value
    this.originalName = field.originalName
    this.url = field.url
  }

  public toStringForView(): string {
    return this.originalName ?? ''
  }
}
